import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "../../Styles/PC/PCDiagnostics.css";

import {
    addDiagnosticCenterAPI,
    getAllDiagnosticCentersAPI,
    deleteDiagnosticCenterAPI
} from "../../services/pcConfigService";

import {
    Delete
} from "@mui/icons-material";
/* ---------------- EMPTY FORM ---------------- */

const EMPTY_CENTER = {
    name: "",
    address: "",
    city: "",
    pincode: "",
    phone: "",
    email: "",
    openTime: "09:00",
    closeTime: "18:00",
    bookingLeadDays: 1,
    dailyCapacity: 10,
    isActive: true
};

const DiagnosticCentersPage = () => {
    const [centers, setCenters] = useState([]);
    const [open, setOpen] = useState(false);
    const [editingCenter, setEditingCenter] = useState(null);
    const [formData, setFormData] = useState(EMPTY_CENTER);
    const [loading, setLoading] = useState(false);

    /* ================= GET API ================= */

    const fetchCenters = async () => {
        try {
            setLoading(true);
            const response = await getAllDiagnosticCentersAPI();

            const mappedCenters = (response?.data || []).map((center) => ({
                id: center._id,
                name: center.centerName,
                city: center.city,
                address: center.address,
                phone: center.phone,
                email: center.email,
                pincode: center.pincode,
                openTime: center.openingTime,
                closeTime: center.closingTime,
                bookingLeadDays: center.bookingLeadDays,
                dailyCapacity: center.dailyCapacity,
                isActive: !center.isDeleted
            }));

            setCenters(mappedCenters);
        } catch (error) {
            toast.error("Failed to fetch diagnostic centers");
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCenters();
    }, []);

    /* ================= OPEN MODAL ================= */

    const handleOpenAdd = () => {
        setEditingCenter(null);
        setFormData(EMPTY_CENTER);
        setOpen(true);
    };

    const handleOpenEdit = (center) => {
        setEditingCenter(center);
        setFormData(center);
        setOpen(true);
    };

    /* ================= POST API ================= */

    const handleSave = async () => {
        if (!formData.name || !formData.address || !formData.city) {
            toast.error("Please fill required fields");
            return;
        }

        const requestObj = {
            centerName: formData.name,
            city: formData.city,
            address: formData.address,
            phone: formData.phone,
            email: formData.email,
            openingTime: formData.openTime,
            closingTime: formData.closeTime,
            bookingLeadDays: formData.bookingLeadDays,
            dailyCapacity: formData.dailyCapacity
        };

        try {
            setLoading(true);

            await addDiagnosticCenterAPI(requestObj);

            toast.success("Center added successfully");

            setOpen(false);
            fetchCenters(); // Refresh list from API
        } catch (error) {
            toast.error("Failed to add center");
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    /* ================= DELETE (Local only for now) ================= */

    const handleDelete = async (id) => {
        const response = await deleteDiagnosticCenterAPI({ _id: id });
        // debugger;
        if (response?.status == 'success') {
            toast.success("Center deleted successfully");
            fetchCenters();
        } else {
            toast.error("Failed to delete center. Please try again later.");
        }
        // setCenters((prev) => prev.filter((c) => c.id !== id));
        // toast.success("Center removed");
    };

    const handleToggleActive = (id) => {
        setCenters((prev) =>
            prev.map((c) =>
                c.id === id ? { ...c, isActive: !c.isActive } : c
            )
        );
    };

    const activeCenters = centers.filter((c) => c.isActive);
    const totalCapacity = activeCenters.reduce(
        (sum, c) => sum + Number(c.dailyCapacity),
        0
    );

    /* ================= UI ================= */

    return (
        <div className="dc-container">
            {/* Header */}
            <div className="dc-header">
                <div>
                    <h2>Diagnostic Centers</h2>
                    <p>
                        Manage partner diagnostic centers for DEXA and face scan
                        services
                    </p>
                </div>

                <button className="add-btn" onClick={handleOpenAdd}>
                    + Add Center
                </button>
            </div>

            {/* Stats */}
            {/* <div className="stats-row">
                <div className="stat-card">
                    <div>Total Centers</div>
                    <h3>{centers.length}</h3>
                </div>

                <div className="stat-card">
                    <div>Active Centers</div>
                    <h3>{activeCenters.length}</h3>
                </div>

                <div className="stat-card">
                    <div>Total Daily Capacity</div>
                    <h3>{totalCapacity}</h3>
                </div>
            </div> */}

            {/* Table */}

            <div className="table-card">


                {loading ? (
                    <p>Loading...</p>
                ) : (
                    <table className="centers-table">
                        <thead>
                            <tr>
                                <th>Center</th>
                                <th>Location</th>
                                <th>Hours</th>
                                <th>Contact</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>

                        <tbody>
                            {centers.map((center) => (
                                <tr key={center.id}>
                                    <td>
                                        <div className="center-name">
                                            {center.name}
                                        </div>

                                    </td>

                                    <td>
                                        <div>{center.city}</div>
                                        <div className="muted">
                                            {center.address}
                                        </div>
                                    </td>

                                    <td>
                                        {center.openTime} -{" "}
                                        {center.closeTime}
                                    </td>

                                    <td>
                                        <div className="center-name">{center.phone}</div>
                                        <div className="center-email">
                                            {center.email}
                                        </div>
                                    </td>

                                    <td>
                                        <span
                                            className={`status-badge ${center.isActive
                                                ? "active"
                                                : "inactive"
                                                }`}
                                        >
                                            {center.isActive
                                                ? "Active"
                                                : "Inactive"}
                                        </span>
                                    </td>

                                    <td>
                                        {/* <button
                                            className="icon-btn edit"
                                            onClick={() =>
                                                handleOpenEdit(center)
                                            }
                                        >
                                            <Edit />
                                        </button> */}
                                        <button className="icon-btn delete" onClick={() => handleDelete(center.id)}>
                                            <Delete />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>

            {/* Modal */}
            {open && (
                <div className="wd-modal-overlay">
                    <div className="wd-modal">
                        <h3>
                            {editingCenter
                                ? "Edit Center"
                                : "Add Center"}
                        </h3>
                        <div className="wp-row">
                            <div className="wp-col-6">
                                <input
                                    placeholder="Center Name"
                                    value={formData.name}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            name: e.target.value
                                        })
                                    }
                                />
                            </div>
                            <div className="wp-col-6">
                                <input
                                    placeholder="City"
                                    value={formData.city}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            city: e.target.value
                                        })
                                    }
                                />
                            </div>
                        </div>
                        <div className="wp-row">
                            <div className="wp-col-6">
                                <input
                                    placeholder="Mobile Number"
                                    value={formData.phone}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            phone: e.target.value
                                        })
                                    }
                                />
                            </div>
                            <div className="wp-col-6">
                                <input
                                    type="email"
                                    placeholder="Email"
                                    value={formData.email}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            email: e.target.value
                                        })
                                    }
                                />
                            </div>
                        </div>
                        <div className="wp-row">
                            <div className="wp-col-6">
                                <input
                                    placeholder="Address"
                                    value={formData.address}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            address: e.target.value
                                        })
                                    }
                                />
                            </div>
                            <div className="wp-col-6">
                                <input
                                    placeholder="Pincode"
                                    value={formData.pincode}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            pincode: e.target.value
                                        })
                                    }
                                />
                            </div>
                        </div>
                        <div className="wp-row">
                            <div className="wp-col-6">
                                <input
                                    type="time"
                                    value={formData.openTime}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            openTime: e.target.value
                                        })
                                    }
                                />
                            </div>
                            <div className="wp-col-6">
                                <input
                                    type="time"
                                    value={formData.closeTime}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            closeTime: e.target.value
                                        })
                                    }
                                />
                            </div>
                        </div>




                        <div className="wd-modal-actions">
                            <button onClick={() => setOpen(false)}>
                                Cancel
                            </button>
                            <button
                                className="add-btn"
                                onClick={handleSave}
                            >
                                Add
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DiagnosticCentersPage;
